<template>
  <div flex="dir:left cross:center">
    <div v-if="items" ref="listItems" v-for="(item,index) in items" :key="index" flex="main:center cross:center" class="color-container" :class="{'active':index==id}"  @click="onClick(item,index)">
      <div class="img-container" :style="{backgroundImage:'url('+item.normalIcon+')'}" flex="main:center cross:center">
        <span style="text-align: center;" v-html="item.name" :class="{'d-span':item.name.indexOf('<br>')!=-1}"></span>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    name: "ColorList",
    data() {
      return {
        options: {
          initialSlide: this.index,
          observer: true,
          observeParents: true,
          slidesPerView: "auto"
        },
        id: 0,
      }
    },
    props: {
      items: {
        default: () => [],
        type: Array,
      }
    },
    methods: {

      onClick(item, index) {
        this.$emit('userclick');
        this.onSelect(item,index,true);
      },
      onSelect(item,index,userClick=false) {
        this.selectId = index;
        this.$emit('select',item,userClick,index);
      },
      getSelectData(){
        return this.items[this.id];
      },
      getSelectItem(){
        return this.$refs.listItems[this.selectId];
      },
    },
    watch: {
      items(val) {

      }
    },
    computed:{
      selectId:{
        set(id){
          this.id = id;
        },
        get(){
          return this.id;
        }
      }
    }
  }
</script>

<style scoped lang="scss">

</style>
